// Plugins
import GLightbox from 'glightbox/dist/js/glightbox.min.js';
import Choices from 'choices.js';


// Local
import Form from './partials/form';
import Header from './partials/header';
import HeaderVisual from './partials/header-visual';

export default function initUitKit($wrapper) {
    $wrapper.querySelectorAll('[data-ui-kit-showcase]').forEach(async ($el) => {
        const UiKitShowcase = await import('./partials/ui-kit-showcase');
        new UiKitShowcase.default($el);
    });
    $wrapper.querySelectorAll('[data-gallery]').forEach(async ($el) => {
        const Gallery = await import('./partials/gallery');
        new Gallery.default($el);
    });
    $wrapper.querySelectorAll('[data-header]').forEach($el => new Header($el));
    $wrapper.querySelectorAll('[data-header-visual]').forEach($el => new HeaderVisual($el));
    $wrapper.querySelectorAll('[data-location-search-visual]').forEach(async ($el) => {
        const LocationSearchVisual = await import('./partials/location-search-visual');
        new LocationSearchVisual.default($el);
    });
    $wrapper.querySelectorAll('[data-location-detail]').forEach(async ($el) => {
        const LocationDetail = await import('./partials/location-detail');
        new LocationDetail.default($el);
    });
    $wrapper.querySelectorAll('[data-cta-image-slider]').forEach(async ($el) => {
        const CtaImageSlider = await import('./partials/cta-image-slider');
        new CtaImageSlider.default($el);
    });
    $wrapper.querySelectorAll('[data-google-review-slider]').forEach(async ($el) => {
        const GoogleReviewSlider = await import('./partials/google-review-slider');
        new GoogleReviewSlider.default($el);
    });
    $wrapper.querySelectorAll('[data-animate]').forEach(async($item) => {
        const Animate = await import('./partials/animate');
        (new Animate.default($item));
    });
    $wrapper.querySelectorAll('[data-form-repeatable]').forEach(async($el) => {
        const FieldsetRepeatable = await import('./partials/fieldset-repeatable');
        (new FieldsetRepeatable.default($el));
    });
    $wrapper.querySelectorAll('[data-form]').forEach($el => new Form($el));
    $wrapper.querySelectorAll('[data-upload]').forEach(async($el) => {
        const UploadControl = await import('./partials/upload-control');
        (new UploadControl.default($el));
    });
    $wrapper.querySelectorAll('[data-alert]').forEach(async($el) => {
        const Alert = await import('./partials/alert');
        (new Alert.default($el));
    });
    $wrapper.querySelectorAll('[data-collapsible]').forEach(async($el) => {
        const Collapsible = await import('./partials/collapsible');
        (new Collapsible.default($el));
    });
    $wrapper.querySelectorAll('[data-modal]').forEach(async($el) => {
        const Modal = await import('./partials/modal');
        (new Modal.default($el));
    });
    $wrapper.querySelectorAll('[data-tabs]').forEach(async($el) => {
        const Tabs = await import('./partials/tabs');
        (new Tabs.default($el));
    });
    $wrapper.querySelectorAll('[data-dropdown]').forEach(async($el) => {
        const Dropdown = await import('./partials/dropdown');
        (new Dropdown.default($el));
    });
    $wrapper.querySelectorAll('[data-password]').forEach(async($el) => {
        const PasswordControl = await import('./partials/password-control');
        (new PasswordControl.default($el));
    });
    $wrapper.querySelectorAll('[data-autocomplete]').forEach(async($el) => {
        const Autocomplete = await import('./partials/autocomplete');
        (new Autocomplete.default($el));
    });
    $wrapper.querySelectorAll('[data-loader]').forEach(async($el) => {
        const Loader = await import('./partials/loader');
        (new Loader.default($el));
    });
    $wrapper.querySelectorAll('[data-mask]').forEach(async ($el) => {
        const IMask = await import('imask');
        new IMask.default($el, {mask: $el.dataset.mask});
    });
    $wrapper.querySelectorAll('[data-href]').forEach(async ($el) => {
        const LinkTo = await import('./partials/link-to');
        (new LinkTo.default($el));
    });
    $wrapper.querySelectorAll('[data-copy-to-clipboard]').forEach(async ($el) => {
        const CopyToClipboard = await import('./partials/copy-to-clipboard');
        (new CopyToClipboard.default($el));
    });
    $wrapper.querySelectorAll('[data-message]').forEach(async ($el) => {
        const Message = await import('./partials/message');
        (new Message.default($el));
    });
    $wrapper.querySelectorAll('[data-select]').forEach(async($el) => {
        (new Choices($el, {
            placeholder: $el.dataset.selectPlaceholder !== undefined,
            placeholderValue: $el.dataset.selectPlaceholder,
            searchEnabled: $el.querySelectorAll('option').length > 8,
            noResultsText: translations.noResultsText,
            noChoicesText: translations.noChoicesText,
            itemSelectText: '',
            uniqueItemText: translations.uniqueItemText,
            customAddItemText: translations.customAddItemText,
            removeItemButton: false,
            shouldSort: false,
            callbackOnCreateTemplates: function(strToEl) {
                return {
                    choice: (classNames, data) => {
                        const el = Choices.defaults.templates.choice(classNames, data); // Get original element
                        const prefix = data.customProperties?.prefix;

                        if (prefix) {
                            // Create the badge/prefix element
                            const badge = strToEl(`${prefix}`);
                            // Prepend or Append it to the original element
                            el.prepend(badge);
                        }
                        return el;
                    },
                    item: (classNames, data) => {
                        const el = Choices.defaults.templates.item(classNames, data); // Get original element
                        const prefix = data.customProperties?.prefix;

                        if (prefix) {
                            // Create the badge/prefix element
                            const badge = strToEl(`${prefix}`);
                            // Prepend or Append it to the original element
                            el.prepend(badge);
                        }
                        return el;
                    },
                }
            }
        }));
    });

    GLightbox({
        selector: '[data-glightbox]',
        touchNavigation: true,
        loop: true,
        autoplayVideos: true
    });

    // Helper method to check if ui-kit is already initialized
    $wrapper.uiKitInitialized = true;
}
